jQuery.fn.size = function() {
	return this.length;
};